<div class="datetool-content">
              <input class="datetool-button" type="button" value="<<" (click)="changeDay(-7)"/>
              <input class="datetool-button" type="button" value="<" (click)="changeDay(-1)"/>
              <input class="datetool-button" type="button" value="今日" (click)="changeDay(0)"/>
              <input class="datetool-button" type="button" value=">" (click)="changeDay(1)"/>
              <input class="datetool-button" type="button" value=">>" (click)="changeDay(7)"/>
            </div>